import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux/store";
import { fetchProfileInfoMenu } from "../../../redux/profile/profileInfo/asyncActions";
import { getProfileInfoMenu } from "../../../redux/profile/profileInfo/selectors";
import { removeTokenToStorage, setSelectedSubscrToStorage } from "../../../utils";
import { setSelectedSubscr } from "../../../redux/subscriptions/slice";
import { setSelectedHalls } from "../../../redux/halls/slice";
import { setCartItems } from "../../../redux/cart/slice";
import { setSelectedHallsToStorage } from "../../../utils/storage/halls";
import { Modal } from "../../../components";
import { Button } from "../../../components";
import { clearAuthData } from "../../../redux/auth/slice";
import styles from "./ProfileScreen.module.scss";

import myProfileIcon from "../../../assets/icons/profilesListIcon.svg";
import myCardsIcon from "../../../assets/icons/card.svg";
import historyIcon from "../../../assets/icons/profileHall.svg";
import logoutIcon from "../../../assets/icons/exitIcon.svg";
import editIcon from "../../../assets/icons/passProfile.svg";
import subscriptionsIcon from "../../../assets/icons/abonProfile.svg";
import hallsIcon from "../../../assets/icons/profileHall.svg";
import settingsIcon from "../../../assets/icons/settingsProfile.svg";

const buttonData = [
  {
    id: 1,
    title: "Мои абонементы",
    icon: subscriptionsIcon,
    route: "/profile/subscriptions",
    type: "normal",
  },
  {
    id: 2,
    title: "Арендованные залы",
    icon: hallsIcon,
    route: "/profile/halls",
    type: "normal",
  },
  {
    id: 3,
    title: "История покупок",
    icon: historyIcon,
    route: "/profile/history",
    type: "normal",
  },
  {
    id: 4,
    title: "Настройки",
    icon: settingsIcon,
    route: "/profile/settings",
    type: "normal",
  },
  {
    id: 5,
    title: "Мои карты",
    icon: myCardsIcon,
    route: "/profile/cards",
    type: "normal",
  },
  {
    id: 6,
    title: "Мои профили",
    icon: myProfileIcon,
    route: "/profile/myprofiles",
    type: "normal",
  },
  {
    id: 7,
    title: "Выйти из профиля",
    icon: logoutIcon,
    type: "logout",
  },
];

export const ProfileScreen: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { profile, isLoading } = useSelector(getProfileInfoMenu);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  useEffect(() => {
    dispatch(fetchProfileInfoMenu());
  }, [dispatch]);

  const formatClientCode = (code: number | string | undefined): string => {
    if (!code && code !== 0) return "000 000";
    const codeStr = String(code).trim();
    if (!codeStr || codeStr === "0" || codeStr === "null" || codeStr === "undefined") {
      return "000 000";
    }
    const digitsOnly = codeStr.replace(/\D/g, "");
    if (!digitsOnly) return "000 000";
    const lastSix = digitsOnly.slice(-6);
    const paddedCode = lastSix.padStart(6, "0");
    return `${paddedCode.slice(0, 3)} ${paddedCode.slice(3, 6)}`;
  };

  const handleLogout = () => {
    removeTokenToStorage();
    handleDeleteAllCartItems();
    dispatch(clearAuthData());
    window.location.href = "/";
  };

  const handleDeleteAllCartItems = () => {
    const emptyCart = { subscriptions: {}, seats: {} };
    dispatch(setCartItems(emptyCart));
    dispatch(setSelectedSubscr(emptyCart.subscriptions));
    setSelectedSubscrToStorage(emptyCart.subscriptions);
    dispatch(setSelectedHalls(emptyCart.seats));
    setSelectedHallsToStorage(emptyCart.seats);
  };

  const handleButtonClick = (button: typeof buttonData[0]) => {
    if (button.type === "logout") {
      setShowLogoutModal(true);
    } else if (button.route) {
      navigate(button.route);
    }
  };

  const user = profile && profile.length > 0 ? profile[0] : null;

  if (isLoading || !user) {
    return (
      <div className={styles.container}>
        <div className={styles.loading}>Загрузка...</div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {/* Карточка основного профиля */}
      <button
        className={styles.profileCard}
        onClick={() => navigate("/profile/edit-my-profile")}
      >
        <div className={styles.myButtonIcon}>
          <div className={styles.buttonTextTitle}>{user.name}</div>
          <div className={styles.buttonCodeText}>
            Код клиента: {formatClientCode((user as any).id)}
          </div>
        </div>
        <img src={editIcon} alt="Редактировать" className={styles.arrow} />
      </button>

      {/* Меню профиля */}
      <div className={styles.menuContainer}>
        {buttonData.map((button) => (
          <button
            key={button.id}
            className={`${styles.menuButton} ${
              button.type === "logout" ? styles.logoutButton : ""
            }`}
            onClick={() => handleButtonClick(button)}
          >
            <img src={button.icon} alt={button.title} className={styles.icon} />
            <span
              className={`${styles.buttonText} ${
                button.type === "logout" ? styles.logoutText : ""
              }`}
            >
              {button.title}
            </span>
          </button>
        ))}
      </div>

      {/* Модальное окно выхода */}
      {showLogoutModal && (
        <Modal
          title="Выход"
          isOpen={showLogoutModal}
          setIsOpen={setShowLogoutModal}
          subTitle="Выйти из учетной записи?"
        >
          <div className={styles.buttons}>
            <Button onClickFunc={handleLogout}>Да</Button>
            <Button onClickFunc={() => setShowLogoutModal(false)}>Нет</Button>
          </div>
        </Modal>
      )}
    </div>
  );
};

